<template>
    <div>
        <img class="mx-auto d-block" alt="idealive" src="@/assets/logo-idealive.png">
        <h1>Oppppppssss! </h1>
        <h3>The {{ resource }} you're looking for are not here</h3>
        <router-link :to="{ name: 'Home'}">Back to the Home Page</router-link>
    </div>
</template>

<script>
export default {
  props: {
    resource: {
      type: String,
      required: true
    }
  }
}
</script>
